module.exports = __webpack_public_path__ + "static/intelectBunk-63ef5dbf7bc13693fb67a486f6e8d6b1.webp";